
import { Component, OnInit, Input } from '@angular/core';
import { CommercialCompetenceService } from '../../../../../commercial-competence/services/commercial-competence.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import * as moment from 'moment';

@Component({
	selector: 'app-ac-proposal-view',
	templateUrl: './ac-proposal-view.component.html'
})

export class AcProposalViewComponent implements OnInit {

	@Input('proposal') proposal = [];
	@Input ('accountClientID') accountClientID;

	private blogTab = false;
	private logTab = false;

	//public cnpjMask = [/[0-9]/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];
	public cnpjMask = [/\w/, /\w/, '.',/\w/, /\w/, /\w/, '.',/\w/, /\w/, /\w/, '/',/\w/, /\w/, /\w/, /\w/, '-',/\w/, /\w/];
	public cpfMask = [/[0-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];

	private proposalData;
	private clientTypes;
	private clientTypeDetails;
	private experienceTypes;
	private ctcList;

	private cultureList;
	private selectedCultureIndex;
	private proposalMarkets;

	private productsList;
	private selectedProductIndex;
	private proposalProducts;

	public isLoaded: boolean = false;

	//Verificadores de exibição por Tipo de Proposta
	private showExperience;
	private showDocs;
	private showFoundation;
	private showConjuge;
	private showClientsizeAndAnual;
	private showCulture;
	private showPartners;
	private showMarketAndPartners;
	private showCommon;

	//Controladores de edição de campos
	private canEdit;

	public maxProposalLc: number;

	constructor(private commercialCompetenceService: CommercialCompetenceService) {
	}

	ngOnInit() {
		console.log("AC", this.proposal);
		this.proposalData = this.proposal;

		this.getClientTypeDetails();
		
		this.getClientTypes();
		
		this.getExperienceTypes();
		
		this.getAlcadaMaxProposalValue();

		this.getCTCByAccountClient();
		
		const dataFundacao = moment(this.proposalData.DataFundacao);
		this.proposalData.DataFundacao = dataFundacao.format("DD/MM/YYYY");

		this.isLoaded = true;
	}

	printDiv(divName) {
		var printContents = document.getElementById(divName).innerHTML;
		var originalContents = document.body.innerHTML;
		document.body.innerHTML = printContents;
		window.print();
		document.body.innerHTML = originalContents;
   }

   getAlcadaMaxProposalValue() {
	this.commercialCompetenceService.getAlcadaMaxProposalValue().subscribe(result => {
		if (result.Success) {

			for (var key in result.Result) {
				var obj = result.Result[key];
				if (obj.Chave === 'vlmaxalcada') {
					this.maxProposalLc = Number(obj.Valor);
				}
					
			}
			
		} else {
			console.log(result);
		}
	}, error => {
		console.log(error);
	});
}

getCTCByAccountClient() {
	this.commercialCompetenceService.getCtcByAccountClient(this.accountClientID).subscribe(result => {
		if (result.Success) {
			this.ctcList = result.Result;
		} else {

		}
	}, error => {
		console.log(error);
	});
}


checkProposalType() {
	//here we decide what user can see based on type

	console.log("Layout da Proposta :B", this.clientTypeDetails.LayoutProposta);

	//RESET
	this.showExperience = false;
	this.showDocs = false;
	this.showFoundation = false;
	this.showConjuge = false;
	this.showClientsizeAndAnual = false;
	this.showCulture = false;
	this.showPartners = false;
	this.showMarketAndPartners = false;
	this.showCommon = false;

	if (this.clientTypeDetails.LayoutProposta == 0) {
		//Não definido
	}

	if (this.clientTypeDetails.LayoutProposta == 1) {
		//Pessoa Fisica
		this.showExperience = true;
		this.showConjuge = true;
		this.showCulture = true;
		this.showCommon = true;
	}
	if (this.clientTypeDetails.LayoutProposta == 2) {
		//Agropecuária
		this.showFoundation = true;
		this.showClientsizeAndAnual = true;
		this.showMarketAndPartners = true;
		this.showCommon = true;
	}
	if (this.clientTypeDetails.LayoutProposta == 3) {
		//Revenda
		this.showFoundation = true;
		this.showClientsizeAndAnual = true;
		this.showMarketAndPartners = true;
		this.showCommon = true;
	}

	if (this.clientTypeDetails.LayoutProposta == 4) {
		//Usina
		this.showFoundation = true;
		this.showClientsizeAndAnual = true;
		this.showMarketAndPartners = true;
		this.showCommon = true;
	}

	if (this.clientTypeDetails.LayoutProposta == 5) {
		//Quimicos
		this.showFoundation = true;
		this.showClientsizeAndAnual = true;
		this.showMarketAndPartners = true;
		this.showCommon = true;
	}
	if (this.clientTypeDetails.LayoutProposta == 6) {
		//PF com PJ
		this.showExperience = true;
		this.showConjuge = true;
		this.showCulture = true;
		this.showDocs = true;
		this.showCommon = true;
	}
	if (this.clientTypeDetails.LayoutProposta == 7) {
		//PF com Parceria
		this.showExperience = true;
		this.showConjuge = true;
		this.showCulture = true;
		this.showPartners = true;
		this.showCommon = true;
	}
}

getClientTypeDetails() {
	this.commercialCompetenceService.getClientTypeByID(this.proposalData.TipoClienteID).subscribe(result => {
		if (result.Success) {
			this.clientTypeDetails = result.Result;
			this.checkProposalType();
		} else {
			console.log(result.Errors);
		}
	}, error => {
		console.log(error);
	});
}

getClientTypes() {
	this.commercialCompetenceService.getClientTypes().subscribe(result => {
		if (result.Success) {
			this.clientTypes = result.Result;
			console.log("Tipos de Cliente", this.clientTypes);
		} else {
			console.log(result.Errors);
		}
	}, error => {
		console.log(error);
	});
}

getExperienceTypes() {
	this.commercialCompetenceService.getExperienceTypes().subscribe(result => {
		if (result.Success) {
			this.experienceTypes = result.Result;
			console.log("Tipos de Experiencia", this.experienceTypes);
		} else {
			console.log(result.Errors);
		}
	}, error => {
		console.log(error);
	});
}


}




// WEBPACK FOOTER //
// ./src/app/account-client/component/account-client-details/proposal-view-modal/ACproposal-view/ac-proposal-view.component.ts